import PropTypes from "prop-types";
import { CLIENT_TYPE } from "../../../../utils/constants";
import Counter from "../../../shared/Counter/Counter";
import { DELIVERY_LOCATION } from "./productConstants";

const ProductQuantity = ({
  isInventory,
  isOrderBlocked,
  receiver,
  setQuantity,
  receiverLocation,
  isActiveReferencedOrder,
}) => {
  const isPickup = receiverLocation === DELIVERY_LOCATION.BASE_STORAGE.id;
  const isOrderBlockedByGroup = !isPickup && isOrderBlocked;

  const disabled =
    isOrderBlockedByGroup ||
    (!isActiveReferencedOrder &&
      (!receiver ||
        (receiver.type !== CLIENT_TYPE.BASE_STORAGE &&
          isInventory &&
          receiverLocation !== DELIVERY_LOCATION.DELIVERY.id)));
  return <Counter disabled={disabled} startValue={1} min={1} onChange={setQuantity} />;
};

ProductQuantity.propTypes = {
  isInventory: PropTypes.bool,
  isOrderBlocked: PropTypes.bool,
  receiver: PropTypes.shape({ type: PropTypes.string }),
  receiverLocation: PropTypes.string,
  setQuantity: PropTypes.func,
  isActiveReferencedOrder: PropTypes.bool,
};

export default ProductQuantity;
